module.exports = __webpack_public_path__ + "img/dan6.059bc9ec.png";